import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceAddLayer from "../components/InvoiceAddLayer";
import ProformaInvoiceAddLayer from "../components/ProformaInvoiceAddLayer";




const ProformaInvoiceAddPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* InvoiceAddLayer */}
        <ProformaInvoiceAddLayer />

      </MasterLayout>

    </>
  );
};

export default ProformaInvoiceAddPage;
